import React from "react";

const VistaBusqueda = ({
  cajeroRol,
  tipoBusqueda,
  cambiarTipoBusqueda,
  criterioBusqueda,
  setCriterioBusqueda,
  isLoading,
  handleBuscarAlumno,
  filtroPlantelOrigen,
  setFiltroPlantelOrigen,
  plantelId,
  nombrePlantel,
  catalogoPlanteles,
  filtroSemestre,
  setFiltroSemestre,
  filtroPeriodo,
  setFiltroPeriodo,
  catalogoPeriodos,
  mensaje,
  resultados,
  handleSeleccionarAlumno
}) => {
  return (
    <>
      <div className="Dashboard-card search-card">
        <h3>Búsqueda de Alumno</h3>
        <p>Selecciona el método de búsqueda e ingresa los datos.</p>
        
        <div className="Login-tabs-container search-tabs" style={{ marginBottom: '15px' }}>
          <button 
            type="button"
            className={`tab-button ${tipoBusqueda === 'matricula' ? 'active' : ''}`}
            onClick={() => cambiarTipoBusqueda('matricula')}
          >
            Por Matrícula
          </button>
          <button 
            type="button"
            className={`tab-button ${tipoBusqueda === 'nombre' ? 'active' : ''}`}
            onClick={() => cambiarTipoBusqueda('nombre')}
          >
            Por Nombre
          </button>
        </div>

        <form onSubmit={handleBuscarAlumno} className="search-form" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          
          <div style={{ display: 'flex', gap: '10px' }}>
            <input
              type="text"
              placeholder={tipoBusqueda === 'matricula' ? "Ej. 20210001001234 (14 dígitos)" : "Ej. Pérez García Carlos"}
              value={criterioBusqueda}
              onChange={(e) => setCriterioBusqueda(e.target.value)}
              className="search-input"
              disabled={isLoading}
              style={{ flexGrow: 1 }}
            />
            <button type="submit" className="btn-search" disabled={isLoading}>
              {isLoading ? "Buscando..." : "Buscar"}
            </button>
          </div>

          {tipoBusqueda === 'nombre' && (
            <div className="filters-container">
              {/* --- 1. FILTRO DE PLANTEL --- */}
              <div className="filter-item">
                <label className="filter-label">Plantel del Alumno</label>
                <select 
                  value={filtroPlantelOrigen} 
                  onChange={(e) => setFiltroPlantelOrigen(e.target.value)}
                  className="search-input"
                  style={{ width: '100%', padding: '8px' }}
                >
                  <option value={plantelId}>{nombrePlantel}</option>
                  <option value="">Todos</option>
                  {catalogoPlanteles
                    .filter((plantel) => String(plantel.id) !== String(plantelId))
                    .map((plantel) => (
                      <option key={plantel.id} value={plantel.id}>
                        {plantel.nombre_plantel}
                      </option>
                  ))}
                </select>
              </div>

              {/* --- 2. FILTRO DE SEMESTRE --- */}
              <div className="filter-item">
                <label className="filter-label">Semestre</label>
                <select 
                  value={filtroSemestre} 
                  onChange={(e) => setFiltroSemestre(e.target.value)}
                  className="search-input"
                  style={{ width: '100%', padding: '8px' }}
                >
                  <option value="">Todos</option>
                  <option value="1">1 - Primero</option>
                  <option value="2">2 - Segundo</option>
                  <option value="3">3 - Tercero</option>
                  <option value="4">4 - Cuarto</option>
                  <option value="5">5 - Quinto</option>
                  <option value="6">6 - Sexto</option>
                </select>
              </div>

              {/* --- 3. FILTRO DE PERIODO --- */}
              <div className="filter-item">
                <label className="filter-label">Periodo Escolar</label>
                <select 
                  value={filtroPeriodo} 
                  onChange={(e) => setFiltroPeriodo(e.target.value)}
                  className="search-input"
                  style={{ width: '100%', padding: '8px' }}
                >
                  <option value="">Todos</option>
                  {catalogoPeriodos.map((periodo) => (
                    <option key={periodo.id} value={periodo.id}>
                        {periodo.nombre_ciclo}
                  </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </form>
        
        {mensaje && <p className="search-message" style={{marginTop: '10px', color: '#d9534f'}}>{mensaje}</p>}
      </div>

      {resultados.length > 0 && (
        <div className="Dashboard-card results-card">
          <h3>Resultados de Búsqueda</h3>
          
          <div className="table-responsive">
            <table className="results-table">
              <thead>
                <tr>
                  <th>Matrícula</th>
                  <th>Nombre Completo</th>
                  <th>Plantel</th> 
                  <th>Grado/Grupo</th>
                  <th>Periodo</th> 
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {resultados.map((al, index) => (
                  <tr key={index}>
                    <td>{al.matricula}</td>
                    <td>{`${al.nombres} ${al.apellido_paterno} ${al.apellido_materno}`}</td>
                    <td>{al.nombre_plantel ? al.nombre_plantel.replace('CECYTEJ', '').trim() : ''}</td> 
                    <td>{al.grado} - {al.grupo}</td>
                    <td>{al.periodo_escolar}</td>
                    <td>
                      <div className="table-actions">
                        
                        {/* Solo el cajero con Pinpad (rol 2) cobra; rol 3 no tiene terminal y el Administrador nunca cobra */}
                        {String(cajeroRol) === "2" && (
                          <button className="btn-select cobrar" onClick={() => handleSeleccionarAlumno(al, 'cobro')}>
                            Cobrar
                          </button>
                        )}

                        {/* El Administrador ve historial de cualquier plantel; los demas roles solo el de su propio plantel (el backend ya lo restringe asi) */}
                        {(String(cajeroRol) === "1" || String(al.plantel_id) === String(plantelId)) && (
                          <button className="btn-select historial" onClick={() => handleSeleccionarAlumno(al, 'historial')}>
                            Historial
                          </button>
                        )}

                        {String(al.plantel_id) === String(plantelId) && (
                          <button className="btn-select validar" onClick={() => handleSeleccionarAlumno(al, 'registrar_pago')}>
                            Validar Pago
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>
      )}
    </>
  );
};

export default VistaBusqueda;